import React from 'react';
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuTrigger,
} from '@/components/ui/context-menu';
import type { AddableLayerType } from '@/lib/layers/layerTypeConfig';
import { AddLayerContextMenuRows } from './AddLayerContextMenuRows';

interface Props {
  children: React.ReactNode;
  onAdd: (type: AddableLayerType) => void;
  disabled?: boolean;
}

/**
 * Right-click anywhere on the preview canvas to add a layer. Mirrors the
 * timeline toolbar's `AddLayerMenu` and the timeline's own context menu — all
 * three render from `LAYER_MENU_ITEMS`.
 *
 * Note `beginDrag` in `LayerCanvasEditor` / `SatisfyingCellEditor` ignores
 * non-primary buttons, so a right-click on a layer box falls through here
 * instead of starting a move/resize.
 */
export const AddLayerContextMenu: React.FC<Props> = ({ children, onAdd, disabled }) => {
  if (disabled) return <>{children}</>;

  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>
        <div className="relative h-full w-full">{children}</div>
      </ContextMenuTrigger>
      <ContextMenuContent className="w-56">
        <AddLayerContextMenuRows onAdd={onAdd} />
      </ContextMenuContent>
    </ContextMenu>
  );
};

export default AddLayerContextMenu;
